"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Icons = _interopRequireWildcard(require("../../packages/IconLibrary"));
var _jsxRuntime = require("react/jsx-runtime");
const Icon = function (_ref) {
  let {
    icon,
    ...props
  } = _ref;
  const Component = Icons[icon];
  return Component ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
    ...props
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: "Icon Not Found"
  });
};
var _default = exports.default = Icon;